module.exports = __webpack_public_path__ + "static/annotation-comment-1-73a502297763bdbf75c582224be54175.png";